import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { t } from '../hooks/useT';

export function LandingPage() {
  const [demoLevel, setDemoLevel] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setDemoLevel((l) => (l + 1) % 5), 1200);
    return () => clearInterval(id);
  }, []);

  const scale = 1 + demoLevel * 0.15;

  return (
    <main className="page landing">
      <header className="hero">
        <h1>Dezoom</h1>
        <p className="tagline">{t('landing.tagline')}</p>
        <div className="demo-zoom" aria-hidden>
          <div
            className="demo-inner"
            style={{ transform: `scale(${scale})` }}
          />
        </div>
        <div className="cta-row">
          <Link to="/play" className="btn primary">{t('landing.cta')}</Link>
          <Link to="/play?guest=1" className="btn secondary">{t('landing.ctaGuest')}</Link>
        </div>
        <Link to="/login" className="link-muted">{t('landing.login')}</Link>
      </header>
    </main>
  );
}
